import React, { useEffect, useState } from "react";
import api from "../api";
import AssignEmployees from "./AssignEmployees";

export default function LoadForm({ user }) {

  const [productTypes, setProductTypes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [form, setForm] = useState({
    product_type_id: "",
    customer_id: "",
    door: "",
    carrier: "",
    vendor: "",
    date: new Date().toISOString().split("T")[0],
    po_number: "",
    sorts: 0,
    cases: 0,
    weight: 0,
  });

  const [total, setTotal] = useState(0);
  const [showAssignment, setShowAssignment] = useState(null);

  useEffect(() => {
    api.get("/product-types-cost").then(r => setProductTypes(r.data));
  }, []);

  useEffect(() => {
    if (user?.role === "admin" || user?.role === "employee") {
      api.get("/customers").then(r => setCustomers(r.data));
    }
  }, [user]);

  useEffect(() => {
    if (form.product_type_id) {
      const p = productTypes.find(x => x.id === Number(form.product_type_id));
      setSelectedProduct(p || null);
    } else setSelectedProduct(null);
  }, [form.product_type_id, productTypes]);

  useEffect(() => {
    if (!selectedProduct) return setTotal(0);

    const cases = Number(form.cases || 0);
    const sorts = Number(form.sorts || 0);
    const weight = Number(form.weight || 0);

    let t = Number(selectedProduct.base_rate || 0);

    const extraCases = Math.max(0, cases - (selectedProduct.base_cases || 0));
    t += extraCases * Number(selectedProduct.case_over_rate || 0);

    const extraSorts = Math.max(0, sorts - (selectedProduct.base_sorts || 0));
    t += extraSorts * Number(selectedProduct.sort_over_rate || 0);

    if (
      selectedProduct.weight_case_threshold &&
      weight > selectedProduct.weight_case_threshold
    ) {
      t += Number(selectedProduct.overweight_charge ?? 0);
    }

    setTotal(Math.round(t * 100) / 100);

  }, [form, selectedProduct]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    if (e) e.preventDefault();
    try {
      const res = await api.post("/loads", form);
      alert("Load saved");
      setShowAssignment(res.data.id);
    } catch {
      alert("Save failed");
    }
  };

  return (
    <div className="container mt-3">

      {/* 🔥 CENTER WRAPPER (DESKTOP FIX) */}
      <div className="mx-auto" style={{ maxWidth: "900px" }}>

        <h4 className="mb-3">Create Load</h4>

        {/* TOTAL */}
        <div className="sticky-top bg-light p-2 mb-3 text-center shadow-sm rounded">
          Estimated: <strong>$ {total.toFixed(2)}</strong>
        </div>

        <form onSubmit={submit}>

          {/* CARD 1 */}
          <div className="card p-3 mb-3 shadow-sm">

            {(user?.role === "admin" || user?.role === "employee") && (
              <div className="mb-2">
                <label>Customer</label>
                <select className="form-control"
                  name="customer_id"
                  value={form.customer_id}
                  onChange={handleChange}
                  required>
                  <option value="">Select Customer</option>
                  {customers.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.user?.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="mb-2">
              <label>Product Type</label>
              <select className="form-control"
                name="product_type_id"
                value={form.product_type_id}
                onChange={handleChange}
                required>
                <option value="">Select</option>
                {productTypes.map(pt => (
                  <option key={pt.id} value={pt.id}>{pt.name}</option>
                ))}
              </select>
            </div>

          </div>

          {/* CARD 2 */}
          <div className="card p-3 mb-3 shadow-sm">

            <div className="row g-2">
              <div className="col-12 col-md-4">
                <label>Door</label>
                <input name="door" className="form-control"
                  value={form.door} onChange={handleChange}/>
              </div>

              <div className="col-12 col-md-4">
                <label>Trailer</label>
                <input name="carrier" className="form-control"
                  value={form.carrier} onChange={handleChange}/>
              </div>

              <div className="col-12 col-md-4">
                <label>Vendor</label>
                <input name="vendor" className="form-control"
                  value={form.vendor} onChange={handleChange}/>
              </div>
            </div>

            <div className="row g-2 mt-2">
              <div className="col-6">
                <label>Date</label>
                <input type="date" name="date"
                  className="form-control"
                  value={form.date} onChange={handleChange}/>
              </div>

              <div className="col-6">
                <label>PO Number</label>
                <input name="po_number"
                  className="form-control"
                  value={form.po_number} onChange={handleChange}/>
              </div>
            </div>

          </div>

          {/* CARD 3 */}
          <div className="card p-3 mb-3 shadow-sm">

            <div className="row g-2">
              <div className="col-4">
                <label>Sorts</label>
                <input type="number" name="sorts"
                  className="form-control"
                  value={form.sorts} onChange={handleChange}/>
              </div>

              <div className="col-4">
                <label>Cases</label>
                <input type="number" name="cases"
                  className="form-control"
                  value={form.cases} onChange={handleChange}/>
              </div>

              <div className="col-4">
                <label>Weight</label>
                <input type="number" name="weight"
                  className="form-control"
                  value={form.weight} onChange={handleChange}/>
              </div>
            </div>

          </div>

          <div style={{ height: showAssignment ? "20px" : "80px" }}></div>

        </form>

      </div>

      {/* 🔥 MOBILE ONLY STICKY */}
      {!showAssignment && (
        <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
          <button className="btn btn-primary w-100" onClick={submit}>
            Save Load ($ {total.toFixed(2)})
          </button>
        </div>
      )}

      {/* 🔥 DESKTOP BUTTON */}
      {!showAssignment && (
        <div className="d-none d-md-block text-center mt-3">
          <button className="btn btn-primary px-5" onClick={submit}>
            Save Load ($ {total.toFixed(2)})
          </button>
        </div>
      )}

      {showAssignment && <AssignEmployees loadId={showAssignment} />}

    </div>
  );
}